export enum CatalogType {
    Spaces = "spaces",
    Events = "events",
    Amenities = "amenities",
    Tags = "tags"
}